import { environment } from '~environments/environment';
import { BehaviorSubject } from 'rxjs';
import { Trailer, TrailerRequest } from '~models/trailer.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TrailerType } from '~v2Models/well.model';
import { Subcarrier } from '~models/subcarrier.model';

export interface CreateUpdateTrailerResponse {
  Success: boolean;
  Error?: string;
}

@Injectable({
  providedIn: 'root',
})
export class TrailerService {
  get route(): string {
    return environment.api;
  }

  private trailers$$ = new BehaviorSubject<Trailer[]>(null);
  public trailers$ = this.trailers$$.asObservable();

  private trailerTypes$$ = new BehaviorSubject<TrailerType[]>(null);
  public trailerTypes$ = this.trailerTypes$$.asObservable();

  private subcarriers$$ = new BehaviorSubject<Subcarrier[]>(null);
  public subcarriers$ = this.subcarriers$$.asObservable();

  constructor(private http: HttpClient) {}

  public getTrailers() {
    this.http.get<Trailer[]>(this.route + '/trailers').subscribe((trailers: Trailer[]) => {
      this.trailers$$.next(trailers);
    });
  }

  public getTrailerTypes() {
    this.http.get(environment.api + '/trailer_types').subscribe((trailerTypes: TrailerType[]) => {
      this.trailerTypes$$.next(trailerTypes);
    });
  }

  public getApLogisticsSubcarriers() {
    this.http.get(this.route + '/subcarriers/lmo').subscribe((subcarriers: Subcarrier[]) => {
      const noneSubcarrier: Subcarrier = {
        name: 'None',
        id: 0,
        billingCode: null,
        scacCode: null,
        brokerId: null,
        driverCount: null,
      }; // Adjust properties as needed
      const sortedSubcarriers = subcarriers.sort((a, b) => a.name.localeCompare(b.name));
      const updatedSubcarriers = [noneSubcarrier, ...sortedSubcarriers];
      this.subcarriers$$.next(updatedSubcarriers);
    });
  }

  public async createTrailer(trailer: TrailerRequest): Promise<CreateUpdateTrailerResponse> {
    try {
      await this.http.post(this.route + '/trailer', trailer).toPromise();
      this.getTrailers();
      return {
        Success: true,
      };
    } catch (e) {
      return {
        Success: false,
        Error: e.error.Message,
      };
    }
  }

  public async updateTrailer(trailerId: number, trailer: TrailerRequest): Promise<CreateUpdateTrailerResponse> {
    try {
      await this.http.put(this.route + '/trailer/' + trailerId, trailer).toPromise();
      this.getTrailers();
      return {
        Success: true,
      };
    } catch (e) {
      return {
        Success: false,
        Error: e.error.Message,
      };
    }
  }

  public async deleteTrailer(trailerId: number): Promise<boolean> {
    try {
      await this.http.delete(this.route + '/trailer/' + trailerId).toPromise();
      this.getTrailers();
      return true;
    } catch (e) {
      return false;
    }
  }
}
